import styled from 'styled-components';
import Table from '../CommonComponents/Table';
import { LinkButton } from '../CommonComponents/Button';

export const Header1 = styled.h1`
  font-size: 22px;
  color: #444;
  font-weight: 600;
  margin: 0 0 24px 0;
`;

export const Subtitle = styled.h2`
  margin: 0;
  font-weight: 400;
  color: #444;
  font-size: 16px;
  line-height: 24px;
`;

export const PageLabel = styled.h2`
  margin: 0;
  font-weight: 400;
  color: #444;
  font-size: 16px;
  line-height: 24px;
  max-width: 50%;

  i {
    font-size: 16px;
    height: 16px;
    width: 16px;
  }
`;

export const InlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const TableWrapper = styled(Table)`
  width: 100%;
  box-sizing: border-box;
  margin: 24px 0;
  border-top: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 0;

  ${Table.Header} {
    ${Table.Row} {
      ${Table.Cell} {
        &:first-child {
          border-top-left-radius: 0;
        }
        &:last-child {
          border-top-right-radius: 0;
        }
        border: none;
        border-radius: 0;
        font-weight: 600;
        font-size: 16px;
        color: #444444;
      }
    }
  }

  ${Table.Row} {
    &:hover {
      background: #f2f9ff;
    }
    ${Table.Cell} {
      padding: 16px 24px;
    }
  }
`;

export const TableCaption = styled.caption`
  font-weight: bold;
  font-size: 18px;
  color: #4b4d4e;
  padding: 16px 24px;
  text-align: left;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border: 1px solid #cccccc;
  border-bottom: none;
  background: #fff;
`;

export const TableCellClickable = styled(Table.Cell)`
  cursor: pointer;
`;

export const TableCellClickableRightAligned = styled(Table.RightAlignedCell)`
  cursor: pointer;
`;

export const TableCellButtonContainer = styled(Table.Cell)`
  width: 80px;
`;

export const TableButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const TableIconButton = styled(LinkButton)`
  margin-left: 12px;
  color: #9c9c9c;

  &:hover {
    color: #444;
  }
`;

export const TableHeaderIcon = styled.i.attrs(({ icon }) => ({
  className: icon,
}))`
  color: #5abee4;
  font-size: 20px;
  display: inline-block;
  padding: 0 10px 0 0;
  line-height: 24px;
  vertical-align: top;
`;

export const NA = styled.span.attrs({
  children: 'N/A',
})`
  color: #999;
`;
